export default __webpack_public_path__ + "static/0110-72053fdcea6808c8a9f887cc928b5f14.png";